// extracted by mini-css-extract-plugin
export default {"btn":"MainButton_btn__is8zz","btnActive":"MainButton_btnActive__2pjTL"};